import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ProfilePending } from '../../../../app/route-states'
import { customerQueryOptions } from '../../../../features/customers/queries'

export const Route = createFileRoute('/_app/customers/$customerId')({
  staticData: { crumb: 'customer' },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(customerQueryOptions(params.customerId)),
  // A cold load on a slow line: the profile's own shape, not the generic three bars.
  pendingComponent: ProfilePending,
  component: Outlet,
})
